import { render, staticRenderFns } from "./PlgUsersApi.vue?vue&type=template&id=0f71f49b&"
import script from "./PlgUsersApi.vue?vue&type=script&lang=js&"
export * from "./PlgUsersApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports